import { ErrorBanner, Spinner } from '@/components/ui';
import ForbiddenPage from '@/pages/errors/ForbiddenPage';
import { useWorkspaceApplications } from '@/lib/applications/workspace-applications';
import type { WorkspaceClientId } from '@/layout/nav.config';

export function RequireAccessibleApplication({
  clientId,
  children,
}: {
  clientId: WorkspaceClientId;
  children: React.ReactNode;
}) {
  const { isLoading, error, applications, hasApplication } = useWorkspaceApplications();

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spinner size="md" />
      </div>
    );
  }

  if (error && applications.length === 0) {
    return (
      <div className="mx-auto max-w-3xl py-6">
        <ErrorBanner error={error} />
      </div>
    );
  }

  if (!hasApplication(clientId)) {
    return <ForbiddenPage />;
  }

  return <>{children}</>;
}
